import SearchIcon from '@mui/icons-material/Search';
import {
  Autocomplete,
  FormControl,
  IconButton,
  InputAdornment,
  styled,
  TextField,
} from '@mui/material';
import _ from 'lodash';
import { useState } from 'react';
import { useDebounce } from 'react-use';
import { useAuthAxios } from '../../hooks/useAuthAxios';
import { FacilitySelect } from '../select/SelectList';
import { SelectHelperText } from '../style/TextStyle';

export const SearchBar = styled(TextField)`
  flex: 1;
  /* max-width: 780px; */
  fieldset {
    border-radius: 10px;
    border: 2px solid #d0bcff;
  }
`;

export function DetailedSearch({
  placeholder = '검색어를 입력하세요.',
  onKeyDown = _.noop,
  onClick = _.noop,
  styleProps = {},
}) {
  const [search, setSearch] = useState('');

  return (
    <SearchBar
      size="small"
      fullWidth
      variant="outlined"
      color="primary"
      sx={{ ...styleProps, flex: 2 }}
      InputProps={{
        endAdornment: (
          <IconButton onClick={e => onClick(e, search)}>
            <SearchIcon sx={{ color: '#5546A9' }} />
          </IconButton>
        ),
      }}
      placeholder={placeholder}
      onKeyDown={onKeyDown}
      onChange={e => {
        setSearch(e.target.value);
      }}
    />
  );
}

const PAGE_SIZE = 1000;

export function SearchAndSelect({
  form,
  helperText = '',
  typeHelperText = '',
}: any) {
  const subCategoryType = form.watch('subCategoryType');
  const subCategoryId = form.watch('subCategoryId');

  const [debouncedSearch, setDebouncedSearch] = useState(subCategoryId);
  const [search, setSearch] = useState('');

  const [getSportingsResult] = useAuthAxios(
    {
      method: 'GET',
      url: `/api/v1/subcategory`,
      params: {
        subCategoryType: subCategoryType,
        title: debouncedSearch,
        pageSize: PAGE_SIZE,
      },
    },
    { manual: false },
  );
  const sportings = _.get(getSportingsResult, 'response.data.result', []);
  useDebounce(
    () => {
      setDebouncedSearch(search);
    },
    304,
    [search],
  );

  return (
    <>
      <FormControl sx={{ width: '100%', flex: 1 }}>
        <FacilitySelect
          value={subCategoryType}
          onChange={(e: any) =>
            form.setValue('subCategoryType', e.target.value)
          }
        />
        <SelectHelperText>{typeHelperText}</SelectHelperText>
      </FormControl>
      <FormControl sx={{ width: '100%', flex: 2 }}>
        <Autocomplete
          size="small"
          freeSolo
          disablePortal
          options={sportings}
          value={
            sportings.find(item => item.subCategoryId === subCategoryId) || null
          }
          getOptionLabel={(o: any) => {
            return `${o.title}`;
          }}
          onInputChange={(e, value) => {
            setSearch(value);
          }}
          onChange={(e, value: any) => {
            form.setValue('subCategoryId', value?.subCategoryId);
          }}
          loading={getSportingsResult.loading}
          loadingText="검색중..."
          renderInput={params => (
            <>
              <TextField
                {...params}
                placeholder="운동기구명을 검색하세요."
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderRadius: '10px',
                    },
                  },
                }}
              />
            </>
          )}
        />
        <SelectHelperText>{helperText}</SelectHelperText>
      </FormControl>
    </>
  );
}
